import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export type NavBlockerTx = { retry: () => void };

export function useNavigationBlocker(
  blocker: (tx: NavBlockerTx) => void,
  when: boolean
): void {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return undefined;
    const nav = navigator as any;
    if (typeof nav.block !== "function") return undefined;

    const unblock = nav.block((tx: any) => {
      blocker({
        retry() {
          unblock();
          tx.retry();
        },
      });
    });

    return unblock;
  }, [navigator, when, blocker]);
}
